import Vue from 'vue';
import Vuex from 'vuex';

import Profile from '@beautybox/core/store/modules/profile';
import Errors from '@beautybox/core/store/modules/errors';
import Global from './store/modules/global.store';
import Services from './store/modules/services.store';
import Online from './modules/online/shared/store/online.store';
import Subscriptions from './modules/subscriptions/shared/store/subscriptions.store';

// import { isMobile } from './utils';

Vue.use(Vuex);

export function createStore(config) {
    Profile.init(config);
    Global.init(config);
    Services.init(config);
    Online.init(config);
    Subscriptions.init(config);

    return new Vuex.Store({
        state: {},
        mutations: {},
        actions: {},
        // getters: { isMobile },
        modules: { Errors, Profile, Global, Online, Services, Subscriptions },
    });
}
